import { createRootRoute, Outlet } from '@tanstack/react-router';

// The chat mini app is login-less and single-purpose — no shell chrome, just the
// active route (a landing hint at / and the live ticket at /t/<token>).
export const Route = createRootRoute({
  component: () => <Outlet />,
});
